import {
  useAppDispatch,
  useAppSelector,
} from "../../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { setAddressSelectionDrawerState } from "../../../../services/redux/slices/globalComponentsToggleSlice";
import { RestaurantTypeEnum } from "../../../../utils/types";
import {
  selectCurrentDeliveryConfig,
  selectMaxEstimatedTime,
} from "../../../../services/redux/selectors/deliverySelectors";

export const useDeliveryInfo = () => {
  const { t } = useTranslationI18();
  const dispatch = useAppDispatch();

  const drawerState = useAppSelector(
    (state) => state.globalComponentsToggleSlice.isOpenAddressSelection
  );
  const delivery = useAppSelector((state) => state.delivery);
  const currentDeliveryConfig = useAppSelector(selectCurrentDeliveryConfig);
  const maxEstimatedTime = useAppSelector(selectMaxEstimatedTime);
  const isEcommerce = useAppSelector(
    (state) =>
      state.config.restaurantInfo?.type === RestaurantTypeEnum.ECOMMERCE
  );

  const deliveryAddressTitle = t(
    isEcommerce
      ? "delivery:delivery-address-title-onlineStore"
      : "delivery:delivery-address-title"
  );
  const deliveryAddressDesc = t("delivery:delivery-address-desc-onlineStore");

  const handleChangeAddress = () => {
    dispatch(setAddressSelectionDrawerState(!drawerState));
  };

  return {
    delivery,
    currentDeliveryConfig,
    maxEstimatedTime,
    isEcommerce,
    deliveryAddressTitle,
    deliveryAddressDesc,
    handleChangeAddress,
    t,
  };
};
